module.exports = __webpack_public_path__ + "media/init/static/fonts/GT-Eesti-Pro-Display-Light-fbaa8fabfdc4f60db030bbc41101da6d.OTF";